import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, AlertCircle, Scale } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-beige-50">
      <Header />
      <main className="pt-20">
        <article className="py-16 px-4">
          <div className="container mx-auto max-w-4xl">
            <div className="glass-strong rounded-3xl p-8 md:p-12 mb-8">
              <div className="flex items-center space-x-3 mb-6">
                <Scale className="w-10 h-10 text-brown-700" />
                <h1 className="text-4xl md:text-5xl font-bold text-brown-900">Terms & Conditions</h1>
              </div>
              <p className="text-lg text-brown-700">
                Last Updated: 02.12.2025
              </p>
            </div>

            <div className="space-y-8">
              <section className="glass rounded-2xl p-8">
                <div className="flex items-center space-x-3 mb-6">
                  <FileText className="w-8 h-8 text-brown-700" />
                  <h2 className="text-3xl font-bold text-brown-900">Acceptance of Terms</h2>
                </div>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    By accessing and using sterling-spins.com ("the Website"), you accept and agree to be 
                    bound by these Terms and Conditions. If you do not agree to these terms, please do not 
                    use our website. We reserve the right to modify these terms at any time, and your 
                    continued use of the website constitutes acceptance of any modifications.
                  </p>
                  <p>
                    Sterling Spins is an independent review and comparison platform for UK online casinos. 
                    We provide information, reviews, guides, and comparison services to help users make 
                    informed decisions about online casino gaming. By using our services, you acknowledge 
                    that you have read, understood, and agree to comply with these terms.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Eligibility</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    Our website is intended for individuals aged 18 years and over only. By using our 
                    website, you represent and warrant that you are at least 18 years old and have the 
                    legal capacity to enter into these terms. If you are under 18, you must not access or 
                    use our website under any circumstances.
                  </p>
                  <p>
                    You must be legally permitted to access online casino review and comparison services 
                    in your jurisdiction. It is your responsibility to ensure that accessing our website 
                    and any casino operators we feature complies with local laws and regulations. We do 
                    not provide services to individuals in jurisdictions where such services are prohibited.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Use of Website Content</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    All content on this website, including text, graphics, logos, images, and software, is 
                    the property of Sterling Spins or its content providers and is protected by copyright, 
                    trademark, and other intellectual property laws. You may access and use our website 
                    content for personal, non-commercial purposes only.
                  </p>
                  <p>
                    You may not reproduce, distribute, modify, create derivative works, publicly display, 
                    publicly perform, republish, download, store, or transmit any content from our website 
                    without prior written permission. Unauthorized use of our content may violate copyright, 
                    trademark, and other laws and may result in legal action.
                  </p>
                  <p>
                    You may print or download one copy of materials from our website for your personal, 
                    non-commercial use, provided you do not remove any copyright or other proprietary 
                    notices from the materials. Any unauthorized use terminates the permission granted 
                    herein.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Affiliate Relationships</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    Sterling Spins operates as an independent review platform and maintains affiliate 
                    relationships with online casinos featured on our website. This means we may receive 
                    compensation when you click through to casino websites or complete registrations with 
                    casino operators through links on our website.
                  </p>
                  <p>
                    Our affiliate relationships do not influence our editorial content, reviews, ratings, 
                    or recommendations. We maintain editorial independence and provide honest, objective 
                    assessments of casino operators regardless of commercial relationships. Our reviews 
                    reflect our genuine opinions and analysis, not the size of affiliate commissions.
                  </p>
                  <p>
                    When you click through to casino websites, you leave our website and become subject 
                    to the terms and conditions, privacy policies, and other policies of those casino 
                    operators. We are not responsible for any transactions, disputes, or issues that arise 
                    between you and casino operators. All casino registrations, deposits, gameplay, and 
                    withdrawals are governed by the respective casino operator's terms and conditions.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <div className="flex items-center space-x-3 mb-6">
                  <AlertCircle className="w-8 h-8 text-brown-700" />
                  <h2 className="text-3xl font-bold text-brown-900">Disclaimer of Warranties</h2>
                </div>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    Our website and its content are provided "as is" and "as available" without warranties 
                    of any kind, either express or implied. We do not warrant that our website will be 
                    available at all times, be error-free, or meet your specific requirements. We make no 
                    representations or warranties regarding the accuracy, completeness, or reliability of 
                    information on our website.
                  </p>
                  <p>
                    We do not guarantee that casino bonuses, promotions, or offers displayed on our website 
                    will be available when you visit casino websites. Casino operators may modify or 
                    withdraw offers at any time, and we are not responsible for changes made by operators. 
                    Always verify current terms and conditions directly with casino operators before 
                    accepting any bonuses or promotions.
                  </p>
                  <p>
                    We are not responsible for any losses, damages, or negative experiences resulting from 
                    your use of casino operators featured on our website. Gambling involves risk, and you 
                    should only gamble with funds you can afford to lose. We do not guarantee winnings or 
                    successful outcomes from any casino gaming activities.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Limitation of Liability</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    To the maximum extent permitted by law, Sterling Spins, its owners, employees, and 
                    affiliates shall not be liable for any indirect, incidental, special, consequential, 
                    or punitive damages, or any loss of profits or revenues, whether incurred directly or 
                    indirectly, or any loss of data, use, goodwill, or other intangible losses resulting 
                    from your use of our website.
                  </p>
                  <p>
                    Our total liability for any claims arising from or related to your use of our website 
                    shall not exceed the amount you paid to us, if any, for accessing our services. In no 
                    event shall we be liable for any damages exceeding one hundred pounds (£100).
                  </p>
                  <p>
                    Nothing in these terms excludes or limits our liability for death or personal injury 
                    caused by our negligence, fraud or fraudulent misrepresentation, or any other liability 
                    that cannot be excluded or limited under applicable UK law.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">User Conduct</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    You agree to use our website only for lawful purposes and in accordance with these 
                    Terms and Conditions. You agree not to use our website to transmit any malicious code, 
                    viruses, or harmful software, attempt to gain unauthorized access to our systems, 
                    interfere with or disrupt our website or servers, or use automated systems to access 
                    our website without permission.
                  </p>
                  <p>
                    You agree not to use our website to collect or harvest personal information about other 
                    users, impersonate any person or entity, or engage in any conduct that restricts or 
                    inhibits anyone's use or enjoyment of our website. We reserve the right to terminate 
                    or suspend your access to our website immediately, without prior notice, for any 
                    violation of these terms.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Third-Party Links</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    Our website contains links to third-party websites, including online casinos and other 
                    service providers. These links are provided for your convenience and do not constitute 
                    an endorsement of the linked websites or their content. We are not responsible for the 
                    content, privacy practices, or terms of service of any third-party websites.
                  </p>
                  <p>
                    When you click on links to casino operators or other third-party websites, you leave 
                    our website and become subject to the terms, conditions, and policies of those websites. 
                    We strongly encourage you to review the terms and conditions and privacy policies of 
                    any third-party websites you visit before providing any personal information or engaging 
                    in any transactions.
                  </p>
                  <p>
                    We are not responsible for any losses, damages, or issues that arise from your 
                    interactions with third-party websites. All transactions, disputes, and communications 
                    with third parties are solely between you and those third parties.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Responsible Gambling</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    Sterling Spins is committed to promoting responsible gambling. We provide information 
                    about responsible gambling tools and resources, but it is your responsibility to gamble 
                    responsibly and within your means. Gambling should be viewed as entertainment, not as a 
                    way to make money or solve financial problems.
                  </p>
                  <p>
                    If you believe you may have a gambling problem, please seek help immediately. Resources 
                    are available through BeGambleAware (www.begambleaware.org), GamCare (www.gamcare.org.uk), 
                    and the National Gambling Helpline (0808 8020 133). We encourage all users to use 
                    responsible gambling tools provided by casino operators, including deposit limits, 
                    self-exclusion, and reality checks.
                  </p>
                  <p>
                    By using our website and accessing casino operators through our links, you acknowledge 
                    that you understand the risks associated with gambling and will gamble responsibly. We 
                    are not responsible for any losses or negative consequences resulting from problematic 
                    gambling behavior.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Indemnification</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    You agree to indemnify, defend, and hold harmless Sterling Spins, its owners, employees, 
                    and affiliates from and against any claims, damages, obligations, losses, liabilities, 
                    costs, or debt, and expenses (including legal fees) arising from your use of our website, 
                    violation of these Terms and Conditions, violation of any third-party rights, or your 
                    interactions with casino operators or other third parties.
                  </p>
                  <p>
                    This indemnification obligation will survive the termination of these Terms and 
                    Conditions and your use of our website.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Governing Law and Jurisdiction</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    These Terms and Conditions are governed by and construed in accordance with the laws of 
                    England and Wales. Any disputes arising from or relating to these terms or your use of 
                    our website shall be subject to the exclusive jurisdiction of the courts of England and 
                    Wales.
                  </p>
                  <p>
                    If any provision of these Terms and Conditions is found to be invalid or unenforceable 
                    by a court of competent jurisdiction, the remaining provisions shall remain in full 
                    force and effect. The invalid or unenforceable provision shall be replaced with a valid 
                    provision that comes closest to the intent of the original provision.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Changes to Terms</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    We reserve the right to modify these Terms and Conditions at any time. We will notify 
                    users of material changes by updating the "Last Updated" date at the top of this page. 
                    Your continued use of our website after changes become effective constitutes acceptance 
                    of the revised terms.
                  </p>
                  <p>
                    We encourage you to review these Terms and Conditions periodically to stay informed 
                    about your rights and obligations when using our website. If you do not agree to any 
                    modifications, you must stop using our website immediately.
                  </p>
                </div>
              </section>

              <section className="glass rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-brown-900 mb-6">Contact Information</h2>
                <div className="space-y-4 text-brown-700 leading-relaxed">
                  <p>
                    If you have questions about these Terms and Conditions, please contact us:
                  </p>
                  <div className="bg-brown-100 rounded-lg p-6">
                    <p className="font-semibold text-brown-900 mb-2">Sterling Spins</p>
                    <p>Email: info@sterling-spins.com</p>
                    <p>Phone: +44 0973 385 308</p>
                    <p>Address: London, United Kingdom</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default TermsConditions;

